import { useCurrentProjectStore } from '@/stores/current-project';
import { useEffect } from 'react';
import { Navigate, Outlet, useParams } from 'react-router-dom';

/**
 * Companion layout. Does NOT render shell — MainLayout already does that.
 * It syncs the URL :id into the current-project store and renders <Outlet />.
 * MainLayout's sidebar subscribes to the URL and renders the "This project"
 * sub-nav itself.
 */
export function ProjectLayout() {
  const { id } = useParams<{ id: string }>();
  const setStored = useCurrentProjectStore((s) => s.setCurrentProjectId);

  useEffect(() => {
    if (id) setStored(id);
  }, [id, setStored]);

  if (!id) return <Navigate to="/projects" replace />;
  return <Outlet />;
}
